import { defineStyle, defineStyleConfig } from '@chakra-ui/react'
import { textStyles } from '../foundations'

const baseStyle = defineStyle({
  fontWeight: 'semibold',
  color: 'text.heading',
  ...textStyles.md,
})

export const FormLabel = defineStyleConfig({
  baseStyle,
})
